import { render, staticRenderFns } from "./EditPdf.vue?vue&type=template&id=2986fa0b&"
import script from "./EditPdf.vue?vue&type=script&lang=ts&"
export * from "./EditPdf.vue?vue&type=script&lang=ts&"
import style0 from "./EditPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports